export default __webpack_public_path__ + "static/media/thumb_01.7b890366.jpg";